const coreGetters = {
    getCountryCode(state) {
        return state.countryCode;
    }
};
export default coreGetters;
